import {message} from "antd";
import i18n from "../../i18n";
import { CommercialControlActionTypes, UserActionTypes } from "../../Actions/actionTypes";

const extractErrorMessage = (payload) => {
    if (!payload) return i18n.t("review:messages.unknown");
    if (typeof payload === "string") {
        if (payload.trim().toUpperCase() === "EMAIL_VERIFICATION_REQUIRED") {
            return i18n.t("login:emailVerification.requiredMessage");
        }
        return payload;
    }
    if (payload.message) return payload.message;
    if (payload.error) {
        if (String(payload.error).trim().toUpperCase() === "EMAIL_VERIFICATION_REQUIRED") {
            return i18n.t("login:emailVerification.requiredMessage");
        }
        return payload.error;
    }   // ton ErrorResponse
    if (payload.detail) return payload.detail; // FastAPI natif
    if (payload.data?.message) return payload.data.message;
    return i18n.t("review:messages.unknown");
};

const getActiveUserId = (state) => {
    const usersState = state?.users || {};
    return usersState.user?.id || usersState.currentUser?.id || null;
};

const shouldResetCommercialControlForUserAction = (action, previousUserId, nextUserId) => {
    if (action.type === UserActionTypes.SET_AUTH && action.payload === false) {
        return true;
    }

    if (![UserActionTypes.SET_USER, UserActionTypes.SET_CURRENT_USER].includes(action.type)) {
        return false;
    }

    if (previousUserId && !nextUserId) {
        return true;
    }

    return Boolean(previousUserId && nextUserId && previousUserId !== nextUserId);
};

export const customMiddleware = store => next => action => {
    const getState = typeof store?.getState === "function" ? store.getState : () => ({});
    const previousUserId = getActiveUserId(getState());
    if (typeof action?.type === "string" && action.type.endsWith("/SET_ERROR")) {
        if (!action.meta?.silent) {
            const msg = extractErrorMessage(action.payload);
            message.error(msg);
        }
    }

    const result = next(action);
    const nextUserId = getActiveUserId(getState());

    if (
        typeof store?.dispatch === "function" &&
        shouldResetCommercialControlForUserAction(action, previousUserId, nextUserId)
    ) {
        store.dispatch({ type: CommercialControlActionTypes.COMMERCIAL_RESET });
    }

    return result;
};
